export default "__VITE_ASSET__QbGz1cEG__"